<template>
  <div class="home-container">
    <AboutMe />
    <Experience />
    <Education />
  </div>
</template>

<script setup lang="ts">
import AboutMe from '@/components/AboutMe.vue'
import Experience from '@/components/Experience.vue'
import Education from '@/components/Education.vue'
</script>

<style scoped>
.home-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
</style>